export default __webpack_public_path__ + "clientLogoNav_vitality.svg";